export function getAccessToken() {
    const item = localStorage.getItem('user')
    try {
        const data = item ? JSON.parse(item) : ''
        if (!data) return ''
        return data.access_token
    } catch {
        return ''
    }
}
